import type { ReactNode } from 'react'

interface AccountingToolPageProps {
  title: string
  description: string
  headerExtra?: ReactNode
  /** When false, page content fills height and only inner regions scroll (e.g. data tables). */
  scrollContent?: boolean
  children: ReactNode
}

/**
 * Page shell for accounting tools — matches Invoices / Distributions layout:
 * white title bar with horizontal padding, scrollable content area below.
 */
export default function AccountingToolPage({
  title,
  description,
  headerExtra,
  scrollContent = true,
  children,
}: AccountingToolPageProps) {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <div className="shrink-0 border-b border-gray-200 bg-white">
        <div className="px-4 py-3 lg:px-6">
          <h1 className="text-xl font-semibold text-gray-900">{title}</h1>
          <p className="mt-0.5 text-sm text-gray-500">{description}</p>
        </div>
        {headerExtra ? (
          <div className="border-t border-gray-200 px-4 py-4 lg:px-6">{headerExtra}</div>
        ) : null}
      </div>

      <div
        className={
          scrollContent
            ? 'flex min-h-0 flex-1 flex-col overflow-y-auto px-3 py-3 sm:px-6 sm:py-4 lg:px-8'
            : 'flex min-h-0 flex-1 flex-col overflow-hidden px-3 py-3 sm:px-6 sm:py-4 lg:px-8'
        }
      >
        <div className={scrollContent ? 'flex flex-col gap-4 pb-8' : 'flex min-h-0 flex-1 flex-col gap-4'}>
          {children}
        </div>
      </div>
    </div>
  )
}
